<template>
    <div>
        <div class="zjdBg" v-if="isBeat">
            <div class="zjdContent">
                <div class="q">
                    <div class="zjd">
                        <div class='hdcc1'>
                            <p class='hdcc'> 活动场次</p>
                          <div v-for="(item,index) in c" :class="item.hdstate==1?'span3':'span1'" :key="index">{{item.start_time}} — {{item.end_time}}
                            <span > {{huodongzt(item)}} </span></div>
                          <hr style="color: #f0ebdc;"/>
                        </div>
                        <div class="popdiv" >
                            <div style="height:425px;">
                                <img style="width: 100%" :src="mubu" alt="">
                            </div>
                            <div class="zjdtitle">
                                <span class="myprize">金蛋来袭，砸出好礼</span>
                                <div>
                                    <div v-if="aaa" >
                                    <img class="imagess" :src="images" alt="">
                                </div>
                                <div class="myprizeimg" v-if="nozhong">
                                    <span>暂时没有中奖信息!</span>
                                </div>
                                </div>
                            </div>
                            <div class="linqu" v-if="!nozhong" @click="getWinning()">领取</div>
                        </div>
                        <!-- 中奖明细页面 -->
                        <div class="prInfo">
                            <div class="prInfo-info">中奖明细</div>
                            <div class="notice">
                                <div class="notice__inner">
                                    <div class="notice__box">

                                      <vue-seamless-scroll :data="listname"  class="seamless-warp">
                                        <ul class="item">
                                          <li v-for="(item,index) in listname" :key="index">
                                            恭喜<span class="title"  style="color:#edd251">{{item|testfile}}</span>中奖
                                          </li>
                                        </ul>
                                      </vue-seamless-scroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import topVue from '../../views/Components/BottomComponent.vue'
import Axios from "@/api/diyaxios";
import Cookies from "js-cookie";
let timmer = true ;
export default {
  name:"zjdjg-component",
    data() {
        return {
            isBeat: true,
            c: [],
            listname: [],
            quit: require('../../assets/zjd_img/quit.png'),
            mubu: require('../../assets/zjd_img/mubu.png'),
            how: false,
            aaa: false,
            datas: [],
            images: '',
            nozhong: false,

        }
    },
    created() {
        this.getTimes();
      this.getproprname();


    },
   mounted() {
     this.getJindan();
   },
  destroyed() {
       timmer=false;
    },
  filters:{
      testfile(value){
        const start = value.slice(0,6);
        const end = value.slice(-4);
        return start+"******"+end;
      }
  },
  methods: {

        huodongzt(item){
          if (item.hdstate==0){
            return '(活动结束)';
          }else if (item.hdstate==1) {
            return  '(正在进行)' ;
          }else if (item.hdstate==2) {
            return  '(即将开始)' ;
          }
        },
        zjdClose() {
            let vm = this;
            vm.isBeat = false;
            // vm.isWinning=false;
          timmer=false;
        },
        // 获取时间段
        getTimes() {
            let vm = this;
            if (Cookies.get('token')) {
                Axios.post('/gold/activate/list', {
                    params: {
                    }
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        token: Cookies.get('token')
                    }
                }
                ).then(res => {
                  res.data.forEach(a=>{
                    a.end_time=a.end_time.slice(11);
                  })
                    this.c = res.data
                    // for(var i in res.data) {
                    // console.log(res.data[i].start_time)
                    // console.log(res.data[i].end_time)
                    // this.a.push(res.data[i].start_time)
                    // this.b.push(res.data[i].end_time)
                    // this.b = res.data[i].end_time
                    // }
                }).catch(err => {

                });
            }
        },
        // 获取所有的金蛋
        getJindan() {
          let vm =this;
            Axios.post('/gold/activate/getrecordlist', {
                params: {
                    selecttj: 'gold_activate_detail.level>0 and gold_activate_detail.level<4',
                    ordertj: '',
                    pageSize:100,
                        pageNum:1,
                }
            }, {
                headers: {
                    "Content-Type": "application/json",
                    token: Cookies.get('token')
                }
            }
            ).then(res => {
                let data = {
                    names: res.user_id
                }
                let list =[];
                for (var i in res.data){
                  list.push(res.data[i].user_id)
                }


                vm.listname=list;
                let dely = (vm.listname.length/4)*2000;
                console.log(dely+"秒")
                if (dely>0&&timmer){
                  setTimeout(()=>{
                    vm.getJindan();
                  },dely)
                }
            })
        },
        // 获取中奖信息
        getproprname() {
            // console.log(Cookies.get("UserID"));
            let vm = this;
            if (Cookies.get('token')) {
                Axios.post('/gold/activate/getrecordlist', {
                    params: {
                        selecttj: 'gold_activate_detail.level>0 and gold_activate_detail.level<4 and gold_activate_record.user_id=' + Cookies.get("UserID"),
                        ordertj: '',
                        pageSize:100,
                        pageNum:1,
                    }
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        token: Cookies.get('token')
                    }
                }
                ).then(res => {
                    // console.log(res.data.length==0){
                    //         console.log(123);
                    // }
                    console.log(res.data);
                    if (res.data.length == 0) {
                        this.nozhong = true
                        this.aaa = false
                    } else if (res.data.length >= 0) {
                        this.aaa = true
                        this.datas = res.data
                        this.nozhong = false
                        this.images = res.data[0].img_url
                    }
                }).catch(err => {

                });
            } else {
                this.$router.push({ name: 'Login' });
            }
        },
        // 跳转到领取业
        getWinning() {
            this.$router.push({ name: "myPrice" })
        }



    }
}
</script>
<style scoped >

.zjd {
    margin: 30px auto;
    background-image: url(../../assets/fm_bg/k3WXJR1QXM.jpg);
    background-size: 1100px 680px;
    width: 70%;
    height: 680px;
    position: relative;

}

.zjdimag {

    width: 100%;
    height: 100%;

}

.zjdBg {
    /* position: fixed;
    width: 100%;
    height: 100%; */
    /* background: rgba(0, 0, 0, 0.8); */
    /* background: rgba(235, 228, 228 / 80%);
    z-index: 100;
    overflow-y: hidden; */



    /* overflow-y: hidden; */
}

.zjdContent {
    height: 100%;
    color: #fff;
}

.q {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.r {
    margin: 0 auto;
}

.r div {
    width: 375px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: yellowgreen;
    border: 1px solid #000;
    font-size: 20px;
}

.zjdBox {
    width: 550px;

    background-color: #fff;
}

.hdcc {
    width: 250px;
    height: 40px;
    background-color: #63000f;
    border-radius: 30px;
    font-size: 20px;
    line-height: 40px;
    margin-top: 30px;
    margin-left: 40px;
  margin-bottom: 5px;
    text-align: center;
}

.prInfo {
    position: absolute;
  margin-top: 30px;
  right: 30px;
    width: 275px;
    height: 320px;
    /* background-color: #540614; */
}

.prInfo-info {
    width: 150px;
    height: 40px;
    background-color: #63000f;
    border-radius: 30px;
    margin: 0 auto;
    margin-bottom: 5px;

    line-height: 40px;
    text-align: center;

}

.notice {
    width: 270px;
    height: 440px;
    border-radius: 8px;
    border: 1px solid #eee;

}

.notice__inner {
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-size: 14px;
    color: #999;
}

/*.notice__box {*/
/*    animation: roll 1112s linear infinite;*/
/*}*/

.notice__item {
    width: 100%;
    height: 100px;
    line-height: 100px;
    padding: 0 12px;
    overflow: hidden;
    text-align: center;
    white-space: nowrap;
}

@keyframes roll {
    0% {
        transform: translatey(0);
    }

    100% {
        transform: translatey(-300px);
    }
}

.zjdtime {
    font-size: 24px;
    position: absolute;
    top: 0;
    left: 0;
}

.zjdClose {
    position: absolute;
    width: 30px;
    height: 30px;
    top: 20px;
    right: 20px;
    cursor: pointer;
    z-index: 109;
}

.zjdCloseimg {
    width: 30px;
    height: 30px;
}

.hdcc1 {
    width: 342px;
    height: 440px;
    margin-left: 30px;
    position: absolute;
    top: 0;
    left: 0;
    color: #FFFFFF;
}

.hdcc1 div {
    width: 342px;
    height: 40px;
    border: 1px solid #f0ebdc;
    border-bottom: 0;
    line-height: 40px;
    text-align: center;
}

.span1{
  /*color: #0fc50f;*/
  /*color: #67c23a;*/
  color: #969896;
}
.span2{
  /*color: #0fc50f;*/
  color: #67c23a;
  /*color: #969896;*/
}
.span3{
  color: white;
  /*color: #67c23a;*/
  /*color: #969896;*/
}

.mask {
    width: 1140px;
    height: 710px;
    background: rgba(0, 0, 0, .7);
    position: fixed;
    overflow: hidden;
    z-index: 222;
    top: -90px;
    left: -320px;
}

.popdiv {
    position: absolute;
    left: 46%;
    top: 11%;
    margin-left: -187px;
    z-index: 226;
    width: 540px;
    height: 480px;
    background-color: #bd2a33;
}

.popbox {
    height: 42px;
    width: 42px;
    position: absolute;
    bottom: 30px;
    left: 50%;
    z-index: 999;
    margin-left: -21px;
    cursor: pointer;
}

.lottery-alertgx {
    -moz-border-radius: 15px;
    border-radius: 15px;
}

.lottery-alertgx,
.lottery-tip {
    max-width: 100%;
    text-align: center;
    z-index: 10000;

    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%)
}

.lottery-alerth1 {
    font-size: 20px;
    font-weight: 400;
    color: #000;
    position: relative;
    margin-top: 20px;
}

.zjdContainer {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #666;
    background-color: #bd2a33;
    height: 100%;
    width: 100%;
}

.zjdtitle {
    position: absolute;
    top: 20px;
    width: 100%;
    text-align: center;
}

.myprize {
    -moz-border-radius: 20px;
    border-radius: 20px;
    padding: 8px 20px;
    color: #edd251;
    font-weight: bold;
    font-size: 18px;

    margin: auto;
    background: #fff;
}

.myprizeimg {
    width: 315px;
    height: 245px;
    /* background-color: red; */
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 104px;
    top: 120px;
    font-size: 30px;
}

.imagess {
    width: 260px;
    height: 260px;
    margin-top: 80px;
}

.myprizetitle {
    position: absolute;
    bottom: 45px;
    left: -5%;
    width: 150px;
    height: 30px;
    border-radius: 30px;
    border: 1px solid #999;
    text-align: center;
    line-height: 30px;
    margin-left: 200px;
}

.linqu {
    position: absolute;
    bottom: 20px;
    left: 37%;
    width: 100px;
    height: 30px;
    border-radius: 30px;
    border: 1px solid #999;
    text-align: center;
    line-height: 30px;
    margin-bottom: 1px;
    cursor: pointer;
}

.nostate {
    width: 500px;
    height: 100px;
    border: 1px solid #fff;
    line-height: 100px;
    text-align: center;
    font-size: 38px;
    position: absolute;
    left: 30%;
    top: 36%;


}
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/myjieguo.vue